import type { RouteObject } from "react-router"
import { Navigate } from "react-router"
import { AdminSettings } from "./components/AccountManagement/AdminSettings"
import { AlertCurationGated } from "./components/AlertCuration/AlertCurationGated"
import { AlertsPage } from "./components/Alerts/Alerts"
import { BiothreatSignalDetailGated } from "./components/PrecomputedBiothreatSignals/BiothreatSignalDetailPage"
import { ChatPage } from "./components/Chat/ChatPage"
import { CriticalThreat } from "./components/CriticalThreats/CriticalThreat"
import { CriticalThreats } from "./components/CriticalThreats/CriticalThreats"
import { VectorDocumentation } from "./components/Documentation/VectorDocumentation"
import { Settings } from "./components/Settings/Settings"
import { WatchedLocations } from "./components/WatchedLocations/WatchedLocations"
import { Analyses } from "./pages/Analyses"
import { Asset } from "./pages/Asset"
import { Authenticate } from "./pages/Authenticate"
import { BioMeshPage } from "./pages/BioMeshPage"
import { CopPage } from "./pages/CopPage"
import { ErrorPage } from "./pages/ErrorPage"
import { Faq } from "./pages/Faq"
import Guidance from "./pages/Guidance"
import { NotFound } from "./pages/NotFound"
import SignIn from "./pages/SignIn"
import SinglePost from "./pages/SinglePost/SinglePost"
import Sources from "./pages/Sources"
import { Texts } from "./pages/Texts"
import { WastewaterOahu } from "./pages/WastewaterOahu"
import { WatchedLocation } from "./pages/WatchedLocation"
import { ROUTES } from "./utils/constants"

export const RouteConfig: RouteObject[] = [
  {
    path: ROUTES.SIGN_IN,
    element: <SignIn />,
  },
  {
    path: ROUTES.WINGMAN_CHAT,
    element: <ChatPage />,
  },
  {
    path: ROUTES.BASE,
    element: <Navigate replace to={ROUTES.PULSE} />,
  },
  {
    path: ROUTES.HOME,
    element: <Navigate replace to={ROUTES.PULSE} />,
  },
  { path: ROUTES.GUIDANCE, element: <Guidance /> },
  { path: ROUTES.ANALYSES, element: <Analyses /> },
  // Legacy route redirects
  { path: "/alerts", element: <Navigate replace to={ROUTES.PULSE} /> },
  { path: ROUTES.PULSE, element: <AlertsPage />, index: true },

  { path: ROUTES.BIOTHREAT_SIGNALS, element: <AlertCurationGated /> },
  {
    path: ROUTES.BIOTHREAT_SIGNAL_DETAIL,
    element: <BiothreatSignalDetailGated />,
  },
  {
    path: ROUTES.WASTEWATER_OAHU,
    element: <WastewaterOahu />,
  },
  {
    path: ROUTES.PREFERENCES,
    element: <Settings />,
  },
  {
    path: ROUTES.DOCUMENTATION,
    element: <VectorDocumentation />,
  },
  {
    path: ROUTES.ASSETS,
    element: <WatchedLocations />,
  },
  { path: ROUTES.ASSET, element: <Asset /> },
  {
    path: ROUTES.LOCATION_DETAILS,
    element: <WatchedLocation />,
  },
  { path: ROUTES.GUIDANCE_POST, element: <SinglePost /> },
  { path: ROUTES.ANALYSIS_POST, element: <SinglePost /> },
  { path: ROUTES.FAQ, element: <Faq /> },
  { path: ROUTES.FAQ_POST, element: <SinglePost /> },
  {
    path: ROUTES.CRITICAL_THREATS,
    element: <CriticalThreats />,
  },
  {
    path: ROUTES.CRITICAL_THREAT,
    element: <CriticalThreat />,
  },
  { path: ROUTES.SOURCES, element: <Sources /> },
  { path: ROUTES.BIO_MESH, element: <BioMeshPage /> },
  { path: ROUTES.COP, element: <CopPage /> },
  {
    path: ROUTES.ORGANIZATIONS,
    element: <AdminSettings />,
  },
  { path: ROUTES.PREFERENCES, element: <Settings /> },
  { path: ROUTES.ERROR, element: <ErrorPage /> },
  { path: ROUTES.LOGIN, element: <Authenticate /> },
  { path: ROUTES.PRIVACY_POLICY, element: <Texts /> },
  { path: ROUTES.TERMS_AND_CONDITIONS, element: <Texts /> },
  { path: "*", element: <NotFound /> },
] // TODO: refactor ROUTES config to handle child routes
